module.exports = __webpack_public_path__ + "img/widget-empty-state.e3f99292.png";